/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S3_P1_AfterInputs */

const tr_onbilgi_s3_p1_after = /** @type {(inputs: Onbilgi_S3_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` sayfasında güncel olarak yayımlanır.`)
};

const en_onbilgi_s3_p1_after = /** @type {(inputs: Onbilgi_S3_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` page.`)
};

const de_onbilgi_s3_p1_after = /** @type {(inputs: Onbilgi_S3_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` veröffentlicht.`)
};

const ru_onbilgi_s3_p1_after = /** @type {(inputs: Onbilgi_S3_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "page." |
*
* @param {Onbilgi_S3_P1_AfterInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s3_p1_after = /** @type {((inputs?: Onbilgi_S3_P1_AfterInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S3_P1_AfterInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s3_p1_after(inputs)
	if (locale === "de") return de_onbilgi_s3_p1_after(inputs)
	if (locale === "ru") return ru_onbilgi_s3_p1_after(inputs)
	return tr_onbilgi_s3_p1_after(inputs)
});